module.exports = __webpack_public_path__ + "img/2.2ec35796.png";